import { ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden
      bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E]"
    >
      {/* Animated gradient overlay */}
      <div
        className="absolute inset-0 bg-gradient-to-r from-[#0E6F7E]/30 via-transparent to-[#1DBF73]/20
        animate-gradient-x"
      ></div>

      {/* Grid pattern */}
      <div
        className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-30"
      ></div>

      {/* Floating orbs */}
      <div className="absolute top-20 left-20 w-72 h-72 bg-[#1DBF73]/20 rounded-full blur-3xl animate-float-slow"></div>
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#0E6F7E]/30 rounded-full blur-3xl animate-float-reverse"></div>

      <div className="container mx-auto px-6 md:px-12 lg:px-12 text-center relative z-10 pt-10 pb-10">
        <div className="max-w-5xl mx-auto space-y-8">
          {/* Headline */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight">
            <span className="block animate-title">
              Partner Program & Masterclass for
            </span>
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#1DBF73] to-[#4FD1C5] animate-title-delay">
              Investment Professionals
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-2xl md:text-3xl text-gray-300 font-light tracking-wide animate-fade-slide delay-200">
            A Strategic Program for Capital Market & Investment Experts
          </p>

          {/* Description */}
          <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed animate-fade-slide delay-400">
            Empower professionals with structured investment frameworks,
            institutional alignment, and long-term capital collaboration.
          </p>

          {/* CTA */}
          <div className="flex justify-center pt-10 animate-fade-slide delay-600">
           <a
  href="https://forms.gle/yS12N6YnnmRH8rG37"
  target="_blank"
  rel="noopener noreferrer"
  className="inline-block"
>
  <button
    className="group px-12 py-4
    bg-gradient-to-r from-[#D4AF37] via-[#F4E4A6] to-[#C9A631]
    text-[#07162E] font-semibold
    rounded-full
    shadow-[0_0_30px_rgba(212,175,55,0.45)]
    hover:shadow-[0_0_50px_rgba(212,175,55,0.65)]
    transition-all duration-300
    transform hover:-translate-y-1 hover:scale-105
    flex items-center gap-3 text-lg
    animate-blink"
  >
    Apply for Program
    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
  </button>
</a>

          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent"></div>

      {/* Animations */}
      <style>{`
        @keyframes gradient-x {
          0%, 100% { transform: translateX(0); }
          50% { transform: translateX(-25%); }
        }
        .animate-gradient-x {
          animation: gradient-x 18s ease-in-out infinite;
        }

        @keyframes floatSlow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-30px); }
        }
        .animate-float-slow {
          animation: floatSlow 14s ease-in-out infinite;
        }

        @keyframes floatReverse {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(30px); }
        }
        .animate-float-reverse {
          animation: floatReverse 16s ease-in-out infinite;
        }

        /* Headline reveal */
        @keyframes titleReveal {
          from {
            opacity: 0;
            transform: translateY(50px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-title {
          animation: titleReveal 1s ease-out forwards;
        }
        .animate-title-delay {
          animation: titleReveal 1s ease-out forwards;
          animation-delay: 0.2s;
        }

        /* Fade + slide */
        @keyframes fadeSlide {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-slide {
          opacity: 0;
          animation: fadeSlide 0.9s ease-out forwards;
        }
        .delay-200 { animation-delay: 0.2s; }
        .delay-400 { animation-delay: 0.4s; }
        .delay-600 { animation-delay: 0.6s; }
      `}</style>
    </section>
  );
}
